import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Downloads } from '../../models/product.model';
import { DocumentButtonComponent } from "../document-button/document-button.component";

export enum DownloadType {
  USER_MANUALS = 'user_manuals',
  CATALOG = 'catalog',
  PRICE_LIST = 'price_list',
  HOW_TO_GUIDE = 'howToGuide'
}

@Component({
  standalone: true,
  selector: 'base-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, DocumentButtonComponent]
})
export class DownloadsComponent {

  DownloadType = DownloadType;

  readonly downloads = input<Downloads>({
    catalog: [],
    howToGuide: [],
    price_list: [],
    user_manuals: []
  });

  get catalogs() {
    return this.downloads()?.catalog || [];
  }
  
  get howToGuides() {
    return this.downloads()?.howToGuide || [];
  }
  
  get price_lists() {
    return this.downloads()?.price_list || [];
  }
  
  get user_manuals() {
    return this.downloads()?.user_manuals || [];
  }

  get areThereAnyDownloads(): boolean {
    const { catalog = [], howToGuide = [], price_list = [], user_manuals = [] } = this.downloads() || {};
    return catalog.length + howToGuide.length + price_list.length + user_manuals.length > 0;
  }
}

